module.exports = __webpack_public_path__ + "img/bg_ways-to-use.7c5e3a04.jpg";